import { SET_SNACK, RESET_SNACK } from '../actions/snackbar'

const getDefaultState = () => {
  return {}
}

const state = {
    snack: {}
}

const mutations = {
    [SET_SNACK]: (state, showSnack) => {
      state.snack = { ...showSnack }
    },
    [RESET_SNACK]: state => {
      Object.assign(state, getDefaultState())
    }
}

export default {
  state,
  mutations,
}